import './App.scss';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Portfolio from './components/Portfolio';
import Emina from './components/Emina';
import AugustusHTML from './components/Augustus/AugustusHTML';
import BerlinHTML from './components/Berlin/BerlinHTML.js';
import Impressum from './components/Impressum';

import './i18n.js'

/**
 * Root component with the route definitions.
 */
function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element = {<Home />}/>
          <Route path='/about' element={<About  />} />
          <Route path='/portfolio' element={<Portfolio  />} />
          <Route path='/contact' element={<Contact  />} />
          <Route path='/emina' element={<Emina  />} />
          <Route path='/historia-romana' element={<AugustusHTML  />} />
          <Route path='/impressum' element={<Impressum  />} />
          <Route path='/berlin' element={<BerlinHTML  />} />

          </Route>
        
      </Routes>
    </>
  );
}

export default App;
